import axios from "axios";
const instance = axios.create({
  baseURL: "http://localhost:1304",
});
export default instance;
